import type { ComponentPropsWithRef, ReactNode } from 'react';

import styles from './IconButton.module.css';

export interface IconButtonProps extends Omit<ComponentPropsWithRef<'button'>, 'children'> {
  /** The accessible name AND the tooltip. Required: an icon alone says nothing to a screen reader. */
  label: string;
  icon: ReactNode;
  /** A short badge (a count) drawn next to the icon. */
  badge?: ReactNode;
  pressed?: boolean;
}

/** Icon-only button (ghost look: no permanent border). `title` gives the native tooltip. */
export function IconButton({
  label,
  icon,
  badge,
  pressed,
  type = 'button',
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={[styles.button, pressed && styles.on, className].filter(Boolean).join(' ')}
      aria-label={label}
      title={label}
      {...(pressed !== undefined && { 'aria-pressed': pressed })}
      {...props}
    >
      {icon}
      {badge !== undefined && badge !== null && <span className={styles.badge}>{badge}</span>}
    </button>
  );
}
